import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconDevice = memo(
  ({ color = '#7f7f7f', size = 24, code = 'Mobile', ...rest }) => {
    const isMobile = code === 'Mobile';
    return (
      <Svg
        width={size}
        height={size}
        viewBox={isMobile ? '0 0 512 512' : '0 0 768 768'}
        {...rest}
      >
        <Path
          fill={color}
          d={
            isMobile
              ? 'M384 0H96C78.4 0 64 14.399 64 32v448c0 17.6 14.399 32 32 32h288c17.6 0 32-14.4 32-32V32c0-17.601-14.4-32-32-32zM240 488.891c-13.746 0-24.891-11.145-24.891-24.891s11.145-24.891 24.891-24.891 24.891 11.145 24.891 24.891-11.145 24.891-24.891 24.891zM384 416H96V64h288v352z'
              : 'M672 448.5v-321H96v321h576zm0-384q25.5 0 45 18.75t19.5 44.25v384q0 25.5-19.5 45T672 576H448.5l63 96v31.5h-255V672l63-96H96q-25.5 0-45-19.5t-19.5-45v-384q0-25.5 19.5-44.25T96 64.5h576z'
          }
        />
      </Svg>
    );
  }
);
